<template>
  <b-link :to="link" class="link-arrow">
    <span class="link-arrow__content">
      <slot />
    </span>

    <i class="icon-arrow-right link-arrow__icon"></i>
  </b-link>
</template>

<script>
export default {
  name: 'LinkArrow',
  props: {
    link: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.link-arrow {
  color: $blue-900;

  &__icon {
    font-size: rem(10px);
    padding-left: rem(8px);
  }

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;

    span {
      text-decoration: underline;
    }
  }
}
</style>
